/* ML filter bar - 30 Aug 2026
   Delegated on document so it survives the AJAX swap of #CollectionAjaxContent. */
(function(){
  var TARGET = 'CollectionAjaxContent';
  var openKey = null;   // which filter panel was open before a swap
  var busy = false;

  function panels(){ return document.querySelectorAll('[data-ml-fbar] [data-ml-f]'); }

  function keyOf(f){
    var l = f.querySelector('.ml-f__lab');
    return l ? l.textContent.trim() : null;
  }

  function closeAll(except){
    panels().forEach(function(f){
      if(f === except) return;
      var b = f.querySelector('[data-ml-toggle]');
      var p = f.querySelector('.ml-f__panel');
      if(b) b.setAttribute('aria-expanded','false');
      if(p) p.hidden = true;
    });
  }

  function reopen(){
    if(!openKey) return;
    panels().forEach(function(f){
      if(keyOf(f) === openKey){
        f.querySelector('.ml-f__panel').hidden = false;
        f.querySelector('[data-ml-toggle]').setAttribute('aria-expanded','true');
      }
    });
  }

  function setBusy(on){
    busy = on;
    var w = document.querySelector('.ml-fbar-wrap');
    if(w) w.classList.toggle('is-busy', on);
    var b = document.querySelector('.ml-fbar__busy');
    if(b) b.hidden = !on;
  }

  function urlFrom(form){
    // drop empty price boxes so they never reach the address bar
    form.querySelectorAll('input[type=number]').forEach(function(i){ i.disabled = (i.value === ''); });
    var qs = new URLSearchParams(new FormData(form)).toString();
    form.querySelectorAll('input[type=number]').forEach(function(i){ i.disabled = false; });
    return form.getAttribute('action') + (qs ? '?' + qs : '');
  }

  function apply(url){
    if(busy) return;
    setBusy(true);
    fetch(url, { credentials: 'same-origin' })
      .then(function(r){ return r.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById(TARGET);
        var here  = document.getElementById(TARGET);
        if(!fresh || !here) { window.location.href = url; return; }
        here.innerHTML = fresh.innerHTML;
        history.pushState({ ml:true }, '', url);
        reopen();
        setBusy(false);
        document.dispatchEvent(new CustomEvent('ml:filtered'));
        var top = document.querySelector('.ml-fbar-wrap');
        if(top){
          var y = top.getBoundingClientRect().top + window.pageYOffset - 90;
          if(window.pageYOffset > y) window.scrollTo({ top:y, behavior:'smooth' });
        }
      })
      .catch(function(){ window.location.href = url; });
  }

  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-ml-toggle]');
    if(t){
      var f = t.closest('[data-ml-f]');
      var p = f.querySelector('.ml-f__panel');
      var willOpen = p.hidden;
      closeAll(f);
      p.hidden = !willOpen;
      t.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      openKey = willOpen ? keyOf(f) : null;
      return;
    }
    if(!e.target.closest('[data-ml-fbar]')){ closeAll(null); openKey = null; }
  });

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape'){ closeAll(null); openKey = null; }
  });

  document.addEventListener('change', function(e){
    if(!e.target.matches('[data-ml-input]')) return;
    var form = e.target.closest('[data-ml-fbar]');
    var f = e.target.closest('[data-ml-f]');
    openKey = f ? keyOf(f) : null;
    apply(urlFrom(form));
  });

  document.addEventListener('submit', function(e){
    var form = e.target.closest('[data-ml-fbar]');
    if(!form) return;
    e.preventDefault();
    apply(urlFrom(form));
  });

  document.addEventListener('input', function(e){
    if(!e.target.matches('[data-ml-search]')) return;
    var q = e.target.value.trim().toLowerCase();
    e.target.closest('.ml-f__panel').querySelectorAll('.ml-f__opt').forEach(function(o){
      o.style.display = (!q || (o.getAttribute('data-ml-name')||'').indexOf(q) > -1) ? '' : 'none';
    });
  });

  window.addEventListener('popstate', function(){ window.location.reload(); });
})();


/* ---- rev 5: price slider AND number boxes (they drive each other), chips, Clear all ---- */
(function(){

  function parts(box){
    return {
      lo:  box.querySelector('[data-ml-rlo]'),
      hi:  box.querySelector('[data-ml-rhi]'),
      bLo: box.querySelector('[data-ml-plov]'),
      bHi: box.querySelector('[data-ml-phiv]'),
      fill:box.querySelector('[data-ml-fill]'),
      max: Number(box.getAttribute('data-pmax')) || 1
    };
  }

  function clamp(n, lo, hi){ return Math.max(lo, Math.min(hi, n)); }

  /* draw the bar, and mirror into the boxes unless the person is typing in them */
  function paint(box, src){
    var p = parts(box);
    if(!p.lo || !p.hi) return;
    var a = Number(p.lo.value), b = Number(p.hi.value);
    if(a > b){ var t = a; a = b; b = t; p.lo.value = a; p.hi.value = b; }
    if(p.fill){ p.fill.style.left = (a / p.max * 100) + '%'; p.fill.style.right = (100 - b / p.max * 100) + '%'; }
    if(src !== 'box'){
      /* empty value => urlFrom() disables it => it stays out of the URL */
      if(document.activeElement !== p.bLo) p.bLo.value = a > 0 ? a : '';
      if(document.activeElement !== p.bHi) p.bHi.value = b < p.max ? b : '';
    }
  }

  /* someone typed a number - move the handles to match */
  function fromBox(box){
    var p = parts(box);
    if(!p.lo || !p.hi) return;
    var a = p.bLo.value === '' ? 0     : clamp(Number(p.bLo.value), 0, p.max);
    var b = p.bHi.value === '' ? p.max : clamp(Number(p.bHi.value), 0, p.max);
    p.lo.value = a;
    p.hi.value = b;
    paint(box, 'box');
  }

  document.addEventListener('input', function(e){
    var box = e.target.closest ? e.target.closest('[data-ml-price]') : null;
    if(!box) return;
    if(e.target.matches('input[type=range]')) paint(box);
    else if(e.target.classList.contains('ml-f__pv')) fromBox(box);
  });

  /* leaving a box with an out-of-range or reversed number tidies it up */
  document.addEventListener('change', function(e){
    var box = e.target.closest ? e.target.closest('[data-ml-price]') : null;
    if(box && e.target.classList.contains('ml-f__pv')){ fromBox(box); paint(box); }
  });

  function resetPrice(form){
    form.querySelectorAll('[data-ml-price]').forEach(function(b){
      var p = parts(b);
      if(p.lo && p.hi){ p.lo.value = p.lo.min; p.hi.value = p.hi.max; }
      if(p.bLo) p.bLo.value = '';
      if(p.bHi) p.bHi.value = '';
      paint(b);
    });
  }

  document.addEventListener('click', function(e){
    var el = e.target.closest ? e.target.closest('[data-ml-unset],[data-ml-unprice],[data-ml-clear]') : null;
    if(!el) return;
    e.preventDefault();
    var form = document.querySelector('[data-ml-fbar]');
    if(!form) return;
    var fired = null;

    if(el.hasAttribute('data-ml-clear')){
      /* ML 2026-10-06: Clear all unticks every box (main and hidden shade), empties the price boxes and asks for
         ONE refresh through the form's own submit path. Before, it fired a change on the last ticked box; when
         that box was a hidden shade (no data-ml-input), or only a price was set, nothing happened. */
      form.querySelectorAll('input[type=checkbox]:checked').forEach(function(i){ i.checked = false; });
      resetPrice(form);
      form.dispatchEvent(new Event('submit', {bubbles:true, cancelable:true}));
      return;
    } else if(el.hasAttribute('data-ml-unprice')){
      /* ML 2026-10-06: same as Clear all - the price boxes carry no data-ml-input, so a change fired on one did nothing. */
      resetPrice(form);
      form.dispatchEvent(new Event('submit', {bubbles:true, cancelable:true}));
      return;
    } else {
      var n = el.getAttribute('data-ml-unset'), v = el.getAttribute('data-ml-unval');
      form.querySelectorAll('input[type=checkbox]').forEach(function(i){
        if(i.name === n && i.value === v){ i.checked = false; fired = i; }
      });
    }

    if(fired) fired.dispatchEvent(new Event('change', {bubbles:true}));
  });

  /* ML 2026-10-06: a typed price is never refused. The form skips the browser's own number check (set in boot(),
     because the form is replaced on every refresh), so a round number below the cheapest piece (500 when the
     floor is 640) applies as typed. Just before the URL is built each typed price is kept inside 0..highest
     price, and a minimum above the maximum is swapped with it. */
  document.addEventListener('submit', function(e){
    var form = e.target && e.target.closest ? e.target.closest('[data-ml-fbar]') : null;
    if(!form) return;
    form.querySelectorAll('[data-ml-price]').forEach(function(b){
      var p = parts(b);
      if(!p.bLo || !p.bHi) return;
      [p.bLo, p.bHi].forEach(function(i){ if(i.value !== '') i.value = clamp(Math.round(Number(i.value)) || 0, 0, p.max); });
      if(p.bLo.value !== '' && p.bHi.value !== '' && Number(p.bLo.value) > Number(p.bHi.value)){
        var t = p.bLo.value; p.bLo.value = p.bHi.value; p.bHi.value = t;
      }
      fromBox(b);
    });
  }, true);   /* capture, so the boxes are tidy before the delegated apply() reads the form */

  function boot(){
    document.querySelectorAll('form[data-ml-fbar]').forEach(function(f){ if(!f.noValidate) f.noValidate = true; });
    document.querySelectorAll('[data-ml-price]').forEach(function(b){
      if(b.dataset.mlPainted) return;   /* paint() mutates the DOM, which re-fires the observer */
      b.dataset.mlPainted = '1';
      paint(b);
    });
  }
  document.addEventListener('DOMContentLoaded', boot);
  new MutationObserver(boot).observe(document.documentElement, {childList:true, subtree:true});
  boot();
})();


/* ---- the slider floor: Shopify's Liquid gives range_max but never a range_min, so the
   cheapest item is fetched once, the first time the Price panel is opened ---- */
(function(){
  var asked = {};

  /* Sorting by price does not reliably put the cheapest card first on this theme -
     R1336 at $2,160 came back ahead of E1034 at $640 - so scan every card and take
     the smallest. One request, and it does not depend on Shopify's ordering. */
  function lowestFrom(html){
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var lo = null;
    doc.querySelectorAll('.grid-product').forEach(function(card){
      var m = card.textContent.match(/\$[\d,]+(\.\d\d)?/);
      if(!m) return;
      var v = Number(m[0].replace(/[^\d.]/g, ''));
      if(!isNaN(v) && v > 0 && (lo === null || v < lo)) lo = v;
    });
    return lo === null ? null : Math.floor(lo);
  }

  function applyFloor(box, floor){
    var lo  = box.querySelector('[data-ml-rlo]');
    var hi  = box.querySelector('[data-ml-rhi]');
    var bLo = box.querySelector('[data-ml-plov]');
    if(!lo || !hi || floor == null) return;
    box.setAttribute('data-pmin', floor);
    lo.min = floor; hi.min = floor;
    bLo.min = floor;
    bLo.placeholder = floor;
    /* an untouched low handle sits on the floor, not out at zero */
    if(bLo.value === '' && Number(lo.value) <= 0){
      lo.value = floor;
      var f = box.querySelector('[data-ml-fill]');
      var max = Number(box.getAttribute('data-pmax')) || 1;
      if(f) f.style.left = (floor / max * 100) + '%';
    }
  }

  document.addEventListener('click', function(e){
    var btn = e.target.closest ? e.target.closest('[data-ml-toggle]') : null;
    if(!btn) return;
    var box = btn.parentNode.querySelector('[data-ml-price]');
    if(!box) return;
    var url = box.getAttribute('data-curl');
    if(!url || asked[url] === 'done') return;
    if(asked[url] === 'busy') return;

    if(typeof asked[url] === 'number'){ applyFloor(box, asked[url]); return; }

    asked[url] = 'busy';
    fetch(url + '?sort_by=price-ascending', {headers:{'X-Requested-With':'XMLHttpRequest'}})
      .then(function(r){ return r.text(); })
      .then(function(html){
        var floor = lowestFrom(html);
        asked[url] = (floor == null) ? 'done' : floor;
        if(floor != null) applyFloor(box, floor);
      })
      .catch(function(){ asked[url] = 'done'; });
  }, true);
})();


/* ---- gemstone roll-up: one visible box, its merged shades ride along hidden ---- */
(function(){
  document.addEventListener('change', function(e){
    var g = e.target && e.target.getAttribute ? e.target.getAttribute('data-ml-group') : null;
    if(!g) return;
    var on = e.target.checked;
    document.querySelectorAll('[data-ml-alias="' + g + '"]').forEach(function(i){ i.checked = on; });
  }, true);   /* capture, so the hidden boxes are set before the delegated apply() reads the form */
})();


/* ---- the gemstone panel spans the whole filter bar ----
   Anchoring it to its own button capped the width at the button's right edge (778px on
   Earrings). The stones want more room than that, and the button's position moves from
   collection to collection, so a fixed offset would overflow somewhere. Measure instead:
   on open, stretch the panel to the bar's box. Only the stone grid gets this - the other
   panels stay tucked under their button where they belong. */
(function(){
  function stretch(btn){
    /* 31 Aug rev 2: on a phone the panels are plain stacked accordions inside the
       drawer. These inline !important writes would beat the stylesheet, so skip them. */
    if(window.innerWidth <= 768) return;
    var wrap = btn.parentNode;
    var panel = wrap.querySelector('.ml-f__panel');
    if(!panel || panel.hidden) return;
    if(!panel.querySelector('.ml-f__opts--3')) return;
    var bar = document.querySelector('.ml-fbar');
    if(!bar) return;
    var b = bar.getBoundingClientRect(), w = wrap.getBoundingClientRect();
    /* the CSS width rules for this panel carry !important, and a plain inline style loses
       to those - so set these with priority too. */
    panel.style.setProperty('min-width', '0', 'important');
    panel.style.setProperty('max-width', 'none', 'important');
    panel.style.setProperty('width', Math.round(b.width) + 'px', 'important');
    panel.style.setProperty('left', Math.round(b.left - w.left) + 'px', 'important');
    panel.style.setProperty('right', 'auto', 'important');
  }
  document.addEventListener('click', function(e){
    var btn = e.target.closest ? e.target.closest('[data-ml-toggle]') : null;
    if(!btn) return;
    setTimeout(function(){ stretch(btn); }, 0);   /* after the theme's own open handler */
  });
  window.addEventListener('resize', function(){
    document.querySelectorAll('[data-ml-toggle][aria-expanded="true"]').forEach(stretch);
  });
})();


/* ---------------------------------------------------------------------------
   31 Aug 2026 rev 2 - phone filtering is a drawer.

   Impulse renders its own Filter button (.js-drawer-open-collection-filters) in
   snippets/collection-grid.liquid, hidden at 769px and up. It used to open
   #FilterDrawer, but snippets/collection-grid-filters.liquid now renders this bar
   instead of the sidebar/drawer, so that markup is never output and the button did
   nothing at all. It is repointed here at the bar itself.

   The open flag lives on <html>, not on the wrap, because the wrap sits inside
   #CollectionAjaxContent and is replaced wholesale on every filter apply - a class
   on the wrap would be thrown away with it. The header and footer are rendered by
   snippets/ml-filter-bar.liquid for the same reason.

   The listener runs on CAPTURE so the theme own drawer handler never fires.
--------------------------------------------------------------------------- */
(function(){
  var MQ = 768;
  function isPhone(){ return window.innerWidth <= MQ; }
  function open(){ document.documentElement.classList.add("ml-drawer-open"); }
  function close(){ document.documentElement.classList.remove("ml-drawer-open"); }

  document.addEventListener("click", function(e){
    if(!e.target || !e.target.closest) return;
    if(e.target.closest(".js-drawer-open-collection-filters")){
      if(!isPhone()) return;
      e.preventDefault(); e.stopPropagation(); open(); return;
    }
    if(e.target.closest("[data-ml-drawer-close]")){ e.preventDefault(); e.stopPropagation(); close(); }
  }, true);

  document.addEventListener("keydown", function(e){ if(e.key === "Escape") close(); });
  window.addEventListener("resize", function(){ if(!isPhone()) close(); });
})();
